import React from 'react';
import styles from './Badge.m.sass';
import cx from 'classnames';

export default function Badge({children}) {
  return (
    <div className={cx(
      styles.badge,
    )}>
      <div className={styles.badgeWrapper}>
        <div className={styles.badgeLabel}>{children}</div>
      </div>
    </div>
  );
}




// WEBPACK FOOTER //
// ./components/badge/Badge.js